import React, { useContext, useState, useEffect } from 'react'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDropzone } from 'react-dropzone'
import CustomTable from '../../product/components/molecules/CustomTable'
import CreditContext from '../../product/context/credit/creditContext'
import AlertContext from '../../product/context/alert/alertContext'
import { currencyFormat } from '../../custom/common/components'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import CustomDialog from '../../product/components/organisms/Dialog'
import AuthContext from '../../product/context/auth/authContext'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import UserContext from '../../product/context/user/userContext'
import { LocalLaundryService } from '@mui/icons-material'

const Credits = (props) => {
    const creditContext = useContext(CreditContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const userContext = useContext(UserContext)
    const { setAlert } = alertContext
    const {
        addCreditBalance,
        search_allusercredit,
        getCreditHistory,
        responseStatus,
        clearResponse,
    } = creditContext
    const {
        all_users,
        getSingleUser,
        single_user,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = userContext
    const { loadUser, user } = authContext

    const [tableBody, setTableBody] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [disable, setDisable] = useState(false)
    const [userData, setUserData] = useState({})

    const data = props.data
    const toggleFullScreenPopup = props.function
    const validationArrayCredit = Yup.object({
        amount: Yup.number()
            .min(1, 'Amount should be greater than 0')
            .required('Required!'),
        // reason_code: Yup.string().required('Required!'),
        credit_notes: Yup.string(),
    })

    const validationArrayDebit = Yup.object({
        amount: Yup.number()
            .min(1, 'Amount should be greater than 0')
            .required('Required!'),
        // reason_code: Yup.string().required('Required!'),
        credit_notes: Yup.string(),
    })

    const initalValuesCreditAndDebit = (removeCredit, balanceCheck) => {
        return {
            amount: 0,
            user_id: 0,
            remove_credit: removeCredit,
            reason_code: '',
            balance_check: balanceCheck,
            credit_notes: '',
            creditor_id: 0,
            credit_type: 'admin',
            admin_id: 0,
        }
    }
    const formikCredits = useFormik({
        initialValues: initalValuesCreditAndDebit(0, 0),
        validateOnBlur: false,
        validationSchema: validationArrayCredit,
        onSubmit: (values) => {
            console.log(user, 'usiiii')
            values.admin_id = user.admin_id
            setIsLoading(true)
            setDisable(true)
            addCreditBalance(values)
            formikData.handleSubmit()
        },
    })

    const formikDebits = useFormik({
        initialValues: initalValuesCreditAndDebit(1, 1),
        validateOnBlur: false,
        validationSchema: validationArrayDebit,
        onSubmit: (values, { resetForm }) => {
            setIsLoading(true)
            setDisable(true)
            console.log(values)
            values.admin_id = user.admin_id
            addCreditBalance(values)
            formikData.handleSubmit()
        },
    })

    const formikData = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: 'date_added ,desc',
            user_id: 0,
            filters: {},
        },
        onSubmit: (values) => {
            getCreditHistory(values)
        },
    })

    useEffect(() => {
        if (single_user.record) {
            setUserData(single_user.record)
        }
    }, [single_user])

    useEffect(() => {
        if (responseStatus?.from === 'addCreditBalance') {
            setDisable(false)
            setAddCreditsModal(false)
            setRemoveCreditsModal(false)
            setAlert(responseStatus.message)
            getCreditHistory(formikData.values)
            getSingleUser({
                id: data.id,
            })
            formikCredits.resetForm()
            formikDebits.resetForm()
        }
        clearResponse()
    }, [responseStatus])

    console.log(data.id, data, 'checkDataId')
    useEffect(() => {
        if (data.id) {
            formikData.values.user_id = data.id
            formikCredits.values.user_id = data.id
            formikDebits.values.user_id = data.id
            // formikData.values.user_id = data.secondaryID
            getCreditHistory(formikData.values)
            getSingleUser({
                id: data.id,
            })
            loadUser()
        }
    }, [data.id])

    useEffect(() => {
        setIsLoading(false)
        if (search_allusercredit) {
            if (search_allusercredit.records.length) {
            }
            setTableBody(
                search_allusercredit.records.length
                    ? search_allusercredit.records
                    : []
            )
        }
    }, [search_allusercredit])

    console.log(search_allusercredit, 'search_allusercredit')

    const addCredits = [
        {
            label: 'Add credits',
            type: 'number',
            placeholder: 'Enter amount',
            class: '',
            name: 'amount',
            formik: formikCredits,
        },
        // {
        //     label: 'Reason Code',
        //     type: 'select',
        //     placeholder: 'Select Reason Code',
        //     class: '',
        //     name: 'reason_code',
        //     options: [
        //         { value: 'Damaged', show: 'Damaged' },
        //         { value: 'Damage package claim', show: 'Damage package claim' },
        //         { value: 'Lost package claim', show: 'Lost package claim' },
        //         {
        //             value: 'Error - Wrong condition',
        //             show: 'Error - Wrong condition',
        //         },
        //         {
        //             value: 'Error - Wrong title/model',
        //             show: 'Error - Wrong title/model',
        //         },
        //         { value: 'NIL', show: 'NIL' },
        //         {
        //             value: 'OTE-one time exception',
        //             show: 'OTE-one time exception',
        //         },
        //         { value: 'Other', show: 'Other' },
        //     ],
        //     formik: formikCredits,
        // },
        {
            label: 'Notes (optional)',
            type: 'textarea',
            placeholder: 'Add notes',
            class: '',
            name: 'credit_notes',
            formik: formikCredits,
        },
    ]

    const removeCredits = [
        {
            label: 'Remove credits',
            type: 'number',
            placeholder: 'Enter amount',
            class: '',
            name: 'amount',
            formik: formikDebits,
        },
        // {
        //     label: 'Reason Code',
        //     type: 'select',
        //     placeholder: 'Select Reason Code',
        //     class: '',
        //     name: 'reason_code',
        //     options: [
        //         { value: 'Damaged', show: 'Damaged' },
        //         { value: 'Damage package claim', show: 'Damage package claim' },
        //         { value: 'Lost package claim', show: 'Lost package claim' },
        //         {
        //             value: 'Error - Wrong condition',
        //             show: 'Error - Wrong condition',
        //         },
        //         {
        //             value: 'Error - Wrong title/model',
        //             show: 'Error - Wrong title/model',
        //         },
        //         { value: 'NIL', show: 'NIL' },
        //         {
        //             value: 'OTE-one time exception',
        //             show: 'OTE-one time exception',
        //         },
        //         { value: 'Other', show: 'Other' },
        //     ],
        //     formik: formikCredits,
        // },
        {
            label: 'Notes (optional)',
            type: 'textarea',
            placeholder: 'Add notes',
            class: '',
            name: 'credit_notes',
            formik: formikDebits,
        },
    ]

    const tableValues = [
        {
            field: 'date_added',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Activity Date',
        },
        {
            field: 'amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
            isTransaction: true,
        },
        {
            field: 'remove_credit',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'remove_credit',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Credit',
                },
                false: {
                    type: 'text',
                    value: 'Debit',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Type',
        },
        // {
        //     field: 'reason_code',
        //     type: 'select',
        //     firstChild: false,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Reason Code',
        // },
        {
            field: 'updatedfirst_name,updatedlast_name',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Updated by',
        },
        {
            field: 'credit_notes',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Notes',
        },
    ]

    const tableActions = []

    const [addCreditsModal, setAddCreditsModal] = useState(false)
    const [removeCreditsModal, setRemoveCreditsModal] = useState(false)

    const toggleAddCredits = () => {
        setAddCreditsModal(!addCreditsModal)
    }
    const toggleRemoveCredits = () => {
        setRemoveCreditsModal(!removeCreditsModal)
    }

    return (
        <FullScreenPopup
            modaltitle={data.status === 'credit' ? 'User Credits' : ''}
            open={data.status === 'credit' ? data.popup : false}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="creditsSection">
                <div className="creditsTop">
                    <h4 className="creditsBalance">
                        User Credits:{' '}
                        <span>
                            {' '}
                            {userData?.deposit_amount
                                ? currencyFormat(userData?.deposit_amount)
                                : currencyFormat(0)}
                        </span>
                    </h4>
                    <div className="creditsActions">
                        <PrimaryButton
                            label="Add Credits"
                            onClick={setAddCreditsModal}
                        />
                        {userData?.deposit_amount > 0 ? (
                            <SecondaryButton
                                label="Remove Credits"
                                onClick={setRemoveCreditsModal}
                            />
                        ) : null}
                    </div>
                </div>

                {isLoading ? (
                    <div>Loading...</div>
                ) : (
                    <CustomTable
                        formik={formikData.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={search_allusercredit}
                        changeTableFunction={getCreditHistory}
                        hideCompactView={props.hideCompactView}
                    />
                )}
            </div>
            <CustomDialog
                title="Add Credits"
                open={addCreditsModal}
                function={toggleAddCredits}
                className="creditsModal"
            >
                <form
                    onSubmit={formikCredits.handleSubmit}
                    autoComplete="nofill"
                >
                    <div className="walletManageCredits">
                        {Object.values(mapData(addCredits))}
                        <PrimaryButton
                            id="credit_submit"
                            type="submit"
                            label="Add Credits"
                            disabled={disable}
                        />
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title="Remove Credits"
                open={removeCreditsModal}
                function={toggleRemoveCredits}
                className="creditsModal"
            >
                <form
                    onSubmit={formikDebits.handleSubmit}
                    autoComplete="nofill"
                >
                    <div className="walletManageCredits">
                        {Object.values(mapData(removeCredits))}
                        <PrimaryButton
                            id="remove_credit_submit"
                            type="submit"
                            label="Remove Credits"
                            disabled={disable}
                        />
                    </div>
                </form>
            </CustomDialog>
        </FullScreenPopup>
    )
}

export default Credits
